export const DEBUG = false
export const API_ENDPOINT = DEBUG? "http://local.ehidongroup.com/api": "https://ehidongroup.com/api"